
export default {
  data () {
    return {
      subscriptionModal: {
        active: false,
        title: '',
        message: '',
      },
    }
  },
  methods: {
    closeSubscriptionModal: function () {
      // [24/01/25] console.log('close Subscription Modal')

      this.subscriptionModal.active = false
      this.subscriptionModal.message = ''
    },
    openSubscriptionModal: function (title = 'Faça um upgrade', message = '') {
      // [24/01/25] console.log('open Subscription Modal')

      this.subscriptionModal.active = true
      this.subscriptionModal.title = title
      this.subscriptionModal.message = message
    },
  },
}
